import { useMemo, useState } from 'react';
import useLocalStorage from 'react-use/lib/useLocalStorage';
import { reportError } from '../utils/reportError';

const randomString = (sizeInBytes: number) => {
  // Allowed characters – all ASCII, 1 byte each
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < sizeInBytes; i++) {
    // Pick random char
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

export const useLocalStorageSafe: typeof useLocalStorage = (
  key,
  initialValue,
  options,
) => {
  const isLocalStorageAvailable = useMemo(() => {
    try {
      const str5KB = randomString(5 * 1024);
      const test = '__storage_test__';
      localStorage.setItem(test, str5KB);
      localStorage.removeItem(test);
      console.info('Local storage is available');
      return true;
    } catch (e) {
      console.warn('Local storage is unavailable');
      reportError(e);
      return false;
    }
  }, []);
  const localStorageHook = useLocalStorage(key, initialValue, options);
  const [value, setValue] = useState<typeof initialValue>(initialValue);

  return isLocalStorageAvailable
    ? localStorageHook
    : [value, setValue, () => undefined];
};
